import { Box, FormControl, FormHelperText, InputLabel, TextField, Tooltip, Typography } from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import DefaultSettings from './settings';

const useStyles = makeStyles((theme) => ({
    inputBase: {
        '& .MuiInputBase-input': {
            padding: '2px !important',
        },
    },
}));

export default function TextFieldComp(props) {
    const classes = useStyles();
    const { value, handleFieldValue, extraProps, disabled, error, required, fullWidth, tooltip, max, contexthelp, length, ...otherProps } = props
    const { label, helperText, name } = otherProps;

    const [inputValue, setInputValue] = useState(value || '');
    const inputRefs = useRef([]);

    useEffect(() => {
        return () => {
            inputRefs.current = [];
        }
    }, [])

    const handleChange = (event, index) => {
        const newValue = inputValue.split('');
        newValue[index] = event.target.value;
        setInputValue(newValue.join(''));

        // Move to the next input box if the current one is filled
        if (event.target.value && index < max - 1) {
            inputRefs.current[index + 1].focus();
        }
    }

    const handleKeyDown = (event, index) => {
        if (event.key === 'Backspace') {
            const newValue = inputValue.split('');
            newValue[index] = '';
            setInputValue(newValue.join(''));

            // Move to the previous input box if the current one is empty
            if (index > 0) {
                inputRefs.current[index - 1].focus();
            }
        }
    }

    const handleBlur = () => {
        if (value !== inputValue)
            handleFieldValue({ target: { value: inputValue, name: name, checked: false }, currentTarget: { dataset: null } });
    }

    let tlabel = <Typography variant='subtitle2' color={error ? 'red' : ''}>{label}{required ? <strong style={{ color: 'red' }}>{' * '}</strong> : ''}
        {tooltip && <Tooltip title={tooltip ? tooltip : null}
            placement="bottom-start" >
            <HelpOutlineIcon color='secondary' fontSize="small" style={{ width: '0.6em', marginBottom: 5, marginLeft: 5 }}
                onClick={(evt) => contexthelp ?
                    DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
        </Tooltip>}
    </Typography>

    return (
        <Box onBlur={() => handleBlur()}>
            <FormControl className={name} fullWidth={fullWidth ? fullWidth : true} error={error} >
                <InputLabel shrink>  {tlabel}&nbsp;</InputLabel>&nbsp;
                <Box display="flex" justifyContent="space-between" >
                    {Array.from({ length: max || 1 }).map((_, index) => (
                        <TextField
                            key={index}
                            value={inputValue[index] || ''}
                            onChange={(event) => handleChange(event, index)}
                            onKeyDown={(event) => handleKeyDown(event, index)}
                            // onBlur={handleBlur}
                            disabled={disabled}
                            error={error}
                            inputProps={{ maxLength: 1, style: { textAlign: 'center' } }}
                            className={classes.inputBase}
                            style={{ width: '2em', height: '2em', margin: '0 0.2em', textAlign: 'center', border: '1px solid  darkgrey', borderRadius: '3px' }}
                            inputRef={(el) => (inputRefs.current[index] = el)}
                        />
                    ))}
                </Box>
                {helperText && <FormHelperText>{helperText}</FormHelperText>}
            </FormControl>
        </Box>
    )
}